import {
  type ViewExtensionContext,
  ViewExtensionProvider,
} from '@blocksuite/affine-ext-loader';
import {
  AutoClearSelectionService,
  BlockElementCommentManager,
  CitationService,
  DefaultOpenDocExtension,
  DNDAPIExtension,
  DocDisplayMetaService,
  DocModeService,
  EditPropsStore,
  EmbedOptionService,
  FileSizeLimitService,
  FontLoaderService,
  LinkPreviewCache,
  LinkPreviewService,
  NavigationAnchorServiceExtension,
  PageViewportServiceExtension,
  ThemeService,
  ToolbarRegistryExtension,
} from '@blocksuite/affine-shared/services';
import { effects as stdEffects } from '@blocksuite/std/effects';
import { InteractivityManager, ToolController } from '@blocksuite/std/gfx';

let registered = false;
export function foundationViewingEffects() {
  if (!registered) {
    stdEffects();
    registered = true;
  }
}
export function registerFoundationViewing(
  context: ViewExtensionContext,
  edgeless: boolean
) {
  context.register([
    DocDisplayMetaService,
    EditPropsStore,
    DefaultOpenDocExtension,
    FontLoaderService,

    DocModeService,
    ThemeService,
    EmbedOptionService,
    NavigationAnchorServiceExtension,
    PageViewportServiceExtension,
    DNDAPIExtension,
    ToolbarRegistryExtension,
    AutoClearSelectionService,
    FileSizeLimitService,
    LinkPreviewCache,
    LinkPreviewService,
    CitationService,
    BlockElementCommentManager,
  ]);

  if (edgeless) context.register([InteractivityManager, ToolController]);
}
export class FoundationViewingExtension extends ViewExtensionProvider {
  override name = 'foundation-viewing';
  override effect() {
    super.effect();
    foundationViewingEffects();
  }
  override setup(context: ViewExtensionContext) {
    super.setup(context);
    registerFoundationViewing(context, this.isEdgeless(context.scope));
  }
}
